import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Folder } from 'src/app/models/folder.model';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

export interface FolderDialogData {
  folder: Folder;
}
@Component({
  selector: 'app-folder-form',
  templateUrl: './folder-form.component.html',
  styleUrls: ['./folder-form.component.scss']
})
export class FolderFormComponent implements OnInit {

  public folder: Folder;
  folderform: FormGroup;
  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<FolderFormComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: FolderDialogData) {
      this.folderform = this.formBuilder.group({
        name: [null, Validators.required]
      });
      this.folder = this.dataDialog.folder ? this.dataDialog.folder : {i: null, n: '', p: null};
    }

  ngOnInit(): void {
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
